import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=7f94a6f1&scoped=true&"
import script from "./ScrollToTop.vue?vue&type=script&lang=js&"
export * from "./ScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=7f94a6f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f94a6f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f94a6f1')) {
      api.createRecord('7f94a6f1', component.options)
    } else {
      api.reload('7f94a6f1', component.options)
    }
    module.hot.accept("./ScrollToTop.vue?vue&type=template&id=7f94a6f1&scoped=true&", function () {
      api.rerender('7f94a6f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/scroll-to-top/ScrollToTop.vue"
export default component.exports